export default __webpack_public_path__ + "static/media/key3.954d05bb.jpg";